import React, {useEffect} from 'react';
import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingleErreursTreso from '../../partials/BlogSingleErreursTreso';
import Footer from '../../partials/Footer';

function BlogPostErreursTreso() {

  useEffect(() => {
    document.title = `7 erreurs à ne pas commettre dans votre gestion de trésorerie | CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingleErreursTreso />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostErreursTreso;